var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignupSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 221 250",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m69.105 81.734c0-3.1193 2.9611-6.2963 5.864-6.2963h61.833c2.961 0 5.864 3.177 5.864 6.2963v25.185h-73.561v-25.185zm58.872 62.963c1.974-1.329 1.974-1.329 3.658-0.809 0.987 0.347 2.148 2.542 1.451 3.119l-15.443 50.371c-0.291 1.675-0.755 2.714-2.207 2.714-0.754 0-1.916-1.039-2.961-1.906l-8.07-8.664-19.16 20.448c-0.7547 0.809-2.6707 2.484-2.6707 2.484-0.6386 0.347-0.987 0.52-1.9159 0-1.916-1.04-0.987-3.119-0.5806-4.852l15.444-50.37c0.5805-1.56 1.045-2.6 2.4965-2.6s1.916 1.04 2.6704 1.791l8.071 8.664 19.217-20.39zm29.436 103.86v-166.82c0-11.784-9.579-22.066-20.611-22.066h-61.775c-11.031 0-20.611 10.224-20.611 22.066v166.82",
    fill: "url(#f)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m207 250h-183.47c-0.8128 0-1.4515-0.635-1.4515-1.444 0-0.808 0.6387-1.444 1.4515-1.444h183.47c0.813 0 1.452 0.636 1.452 1.444 0 0.809-0.639 1.444-1.452 1.444z",
    fill: "#0300C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m167.96 58.125c-0.174-0.1155-0.348-0.2311-0.465-0.4044-0.696-0.8664-0.522-2.195 0.349-2.8304l21.25-16.463c0.87-0.6932 2.206-0.5199 2.844 0.3466 0.697 0.8665 0.523 2.195-0.348 2.8304l-21.192 16.463c-0.754 0.5777-1.741 0.5777-2.438 0.0578z",
    fill: "url(#e)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m136.58 34.523c-0.174-0.0578-0.406-0.1155-0.58-0.231-0.929-0.6354-1.22-1.8485-0.639-2.8305l14.573-22.528c0.639-0.92423 1.858-1.213 2.845-0.6354 0.929 0.6354 1.219 1.8485 0.639 2.8304l-14.573 22.528c-0.523 0.7509-1.452 1.0397-2.265 0.8664z",
    fill: "url(#d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m57.404 34.43c-0.1161 0.1733-0.2322 0.3466-0.4064 0.4621-0.8709 0.7509-2.1482 0.6354-2.9029-0.2311l-17.534-20.275c-0.7547-0.8664-0.6386-2.1372 0.2323-2.8882 0.8709-0.7509 2.1482-0.6354 2.9029 0.2311l17.592 20.333c0.5226 0.6354 0.5806 1.6174 0.1161 2.3683z",
    fill: "url(#c)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m28.974 59.342c-0.042 0.2272-0.1306 0.387-0.2298 0.6037-0.5887 0.9485-1.8822 1.2379-2.8363 0.6502l-22.788-14.378c-0.95408-0.5878-1.2472-1.8756-0.65847-2.8241 0.58878-0.9485 1.8822-1.2379 2.8363-0.6502l22.799 14.322c0.7933 0.4993 1.0924 1.4358 0.8777 2.2772z",
    fill: "url(#b)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m95.95 31.26c-0.1904 0.0819-0.369 0.107-0.6033 0.1213-1.1157 0.0826-2.0438-0.7454-2.0993-1.8797l-1.3699-26.758c-0.0555-1.1343 0.7792-2.0986 1.895-2.1811 1.1157-0.082532 2.0439 0.74541 2.0993 1.8797l1.3699 26.758c0.0906 0.9637-0.4746 1.7428-1.2917 2.0598z",
    fill: "url(#a)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m66.783 127.77c-0.5806 18.485-9.6959 40.724-24.675 40.724s-25.256-23.394-24.095-40.724c2.4966-37.026 25.546-60.652 25.546-60.652s23.224 23.568 23.224 60.652z",
    fill: "#0300C1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m41.353 248.5c-0.8129 0-1.4515-0.635-1.4515-1.444l-0.3484-102.7c0-0.808 0.6387-1.444 1.4515-1.444 0.8129 0 1.4515 0.636 1.4515 1.444l0.3484 102.7c0 0.809-0.6387 1.444-1.4515 1.444z",
    fill: "#0300C1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m161.13 215.22c-5.922-1.849-11.321-6.297-12.425-12.304-0.812-4.39 0.813-9.185-0.928-13.344-1.51-3.754-5.4-6.065-8.129-9.069-7.489-8.26-5.283-22.932 4.355-28.708 5.225-3.12 11.96-3.871 16.14-8.145 3.89-3.986 4.587-9.878 6.909-14.846 3.077-6.585 9.638-11.841 17.012-12.303 7.431-0.462 15.095 4.621 16.314 11.784 0.639 3.639-0.348 7.393 0.233 11.033 0.987 6.642 6.676 11.552 11.495 16.347 4.819 4.794 9.406 11.322 7.49 17.791-1.335 4.563-5.748 8.087-6.038 12.882-0.232 3.927 2.438 7.451 3.367 11.321 1.916 8.145-4.935 16.232-13.005 19.005-7.606 2.599-15.444 1.559-23.166 0.635-6.386-0.866-13.295-0.115-19.624-2.079z",
    fill: "#04DFEA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m201.31 152.09c-0.755-0.462-1.858-0.347-2.438 0.289l-16.896 18.138v-23.972c0-0.751-0.754-1.387-1.741-1.387-0.929 0-1.742 0.636-1.742 1.387v57.07l-17.418-18.715c-0.581-0.636-1.684-0.751-2.439-0.289-0.754 0.462-0.929 1.329-0.348 1.964l19.914 21.373c0.058 0.058 0.175 0.173 0.291 0.231v38.586c0 0.751 0.754 1.387 1.742 1.387 0.928 0 1.741-0.636 1.741-1.387v-71.627l19.682-21.084c0.581-0.578 0.465-1.502-0.348-1.964z",
    fill: "#0300C1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 54.398,
    x2: 157.44,
    y1: 154.12,
    y2: 154.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE6E6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 171.25,
    x2: 191.1,
    y1: 39.622,
    y2: 44.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0017BF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#032CC3",
    offset: 0.033867
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0857CB",
    offset: 0.113
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D7ED2",
    offset: 0.1983
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#119ED8",
    offset: 0.2888
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14B8DD",
    offset: 0.3859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17CDE1",
    offset: 0.4921
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19DBE4",
    offset: 0.6122
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE3E6",
    offset: 0.7579
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE6E6",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 133.67,
    x2: 154.11,
    y1: 15.844,
    y2: 14.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0017BF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#032CC3",
    offset: 0.033867
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0857CB",
    offset: 0.113
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D7ED2",
    offset: 0.1983
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#119ED8",
    offset: 0.2888
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14B8DD",
    offset: 0.3859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17CDE1",
    offset: 0.4921
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19DBE4",
    offset: 0.6122
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE3E6",
    offset: 0.7579
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE6E6",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 39.409,
    x2: 43.534,
    y1: 31.709,
    y2: 11.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0017BF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#032CC3",
    offset: 0.033867
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0857CB",
    offset: 0.113
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D7ED2",
    offset: 0.1983
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#119ED8",
    offset: 0.2888
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14B8DD",
    offset: 0.3859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17CDE1",
    offset: 0.4921
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19DBE4",
    offset: 0.6122
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE3E6",
    offset: 0.7579
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE6E6",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 10.119,
    x2: 8.2534,
    y1: 62.981,
    y2: 42.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0017BF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#032CC3",
    offset: 0.033867
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0857CB",
    offset: 0.113
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D7ED2",
    offset: 0.1983
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#119ED8",
    offset: 0.2888
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14B8DD",
    offset: 0.3859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17CDE1",
    offset: 0.4921
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19DBE4",
    offset: 0.6122
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE3E6",
    offset: 0.7579
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE6E6",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 82.529,
    x2: 98.07,
    y1: 18.266,
    y2: 4.9402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0017BF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#032CC3",
    offset: 0.033867
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0857CB",
    offset: 0.113
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D7ED2",
    offset: 0.1983
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#119ED8",
    offset: 0.2888
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14B8DD",
    offset: 0.3859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17CDE1",
    offset: 0.4921
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19DBE4",
    offset: 0.6122
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE3E6",
    offset: 0.7579
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE6E6",
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupSuccess);
export default __webpack_public_path__ + "static/media/signupSuccess.a947054d50268370d4caa34ce4d8b387.svg";
export { ForwardRef as ReactComponent };